import { useToasts } from "react-toast-notifications";
import service from "../../../../api/services";
import constant from "../../../../constants/constant";
import {
    DefaultPermissionType,
    FormatDefaultPermissionType,
    GetRoleProps,
    HandleStorePermissionToggleProps,
    StorePermissionApiType,
    THandleSelectedRoleProps,
    TModifiedSubAdminApiProps,
    TreeNode
} from "../interface";

// First, let's define the missing interface


export const useRole = () => {
    const { addToast } = useToasts();

    // INFO :- function to formate the data to set default permission in case of edit subAdmin
    const formatDefaultPermission = (
        data: StorePermissionApiType[]
    ): FormatDefaultPermissionType => {
        const result: FormatDefaultPermissionType = {};

        data?.forEach(({ store_id, permissions }) => {
            result[store_id] = {
                isChecked: true,
                permission: permissions,
            };
        });

        return result;
    };
    // end

    //function to call api and get the data of role
    const getSubAdminRoleOption = async ({
        setRolesList,
        setRolesData,
    }: GetRoleProps) => {
        try {
            let response = await service.roles.list({
                role_for: constant.ROLE_FOR[0].value,
            });
            setRolesData(response?.data?.data);
            let list = response.data.data.map((item: any) => {
                return {
                    key: item.id,
                    value: item.role_name,
                    label: item.role_name,
                };
            });
            setRolesList(list);
        } catch (error: any) {
            console.error("error>>>>", error);
            addToast(error?.response?.data?.message || "", {
                appearance: "error",
                autoDismiss: true,
                autoDismissTimeout: 3000,
            });
        }
    };
    // end

    // Helper function to find common permissions between two TreeNode arrays
    const findCommonPermissions = (
        rolePermissions: TreeNode[],
        storePermissions: TreeNode[]
    ): TreeNode[] => {
        const result: TreeNode[] = [];

        for (const rolePerm of rolePermissions) {
            const matchingStorePerm = storePermissions.find(
                (storePerm) =>
                    storePerm.id === rolePerm.id ||
                    storePerm.perm_code === rolePerm.perm_code
            );

            if (matchingStorePerm) {
                // Create a new node with common properties
                const commonNode: TreeNode = {
                    module_name: rolePerm.module_name,
                    perm_code: rolePerm.perm_code,
                    id: rolePerm.id,
                    isChecked: rolePerm.isChecked && matchingStorePerm.isChecked,
                    child: [],
                };

                // Recursively find common child permissions
                if (rolePerm.child.length > 0 && matchingStorePerm.child.length > 0) {
                    commonNode.child = findCommonPermissions(
                        rolePerm.child,
                        matchingStorePerm.child
                    );
                }

                result.push(commonNode);
            }
        }

        return result;
    };
    // end

    // function to selection of role drop down
    const handleSelectedRole = async ({
        role,
        rolesData,
        defaultPermission,
        setDefaultPermission,
        subAdmin,
        setSubAdmin,
    }: THandleSelectedRoleProps) => {
        // Find the role object that matches the selected role key
        const matchedRole = rolesData?.find((item) => item.id === role.key);
        if (!matchedRole) return;

        // Initialize updated permission object
        let updatedPermission: DefaultPermissionType = {};

        // Get all store keys from defaultStorePermission
        const storeKeys = Object.keys(defaultPermission);

        // Find common permissions for each store
        for (const storeKey of storeKeys) {
            const storePermissionData = defaultPermission[storeKey];

            if (storePermissionData && storePermissionData.permission) {

                // Find common permissions between role and store
                const commonPermissions = findCommonPermissions(
                    matchedRole.permissions,
                    storePermissionData.permission
                );

                updatedPermission[storeKey] = {
                    isChecked: storePermissionData.isChecked,
                    permission: commonPermissions as [],
                };
            }
        }

        // Update state
        setDefaultPermission(updatedPermission);
        setSubAdmin({ ...subAdmin, role_id: role });
    };
    // end

    //function to modifiedData of sub-admin data and default permission
    const modifiedSubAdminApiData = ({ sunAdminArray, storeList, rolesData, role_id, getStructuredPermissionStoreWise }: TModifiedSubAdminApiProps): StorePermissionApiType[] => {
        // Find the role object that matches the selected role key
        const matchedRole = rolesData?.find((item) => item.id === role_id);


        // Create a Set of existing store_ids for quick lookup
        const existingStoreIds = new Set(
            sunAdminArray.map((item) => item.store_id)
        );

        // Add missing stores with empty permissions
        // TODO matchedRole?.permissions is wrong we need to filter the permission
        const missingStores: StorePermissionApiType[] = storeList
            .filter(({ value }) => !existingStoreIds.has(value))
            .map(({ value }) => ({
                store_id: value,
                permissions: matchedRole?.permissions ?? [],
            }));
        Promise.all(
            missingStores.map((item: { store_id: string }) =>
                getStructuredPermissionStoreWise(item.store_id, false)
            )
        );

        return [...sunAdminArray, ...missingStores]
    }
    // end

    //function to handle the show and hide of whole permission tree
    const handleStorePermissionToggle = (
        { id, isChecked, subAdminPermission,defaultPermission, rolesData, role_id, setDefaultPermission, getStructuredPermissionStoreWise }: HandleStorePermissionToggleProps
    ) => {
        if (isChecked) {
            // Initialize updated permission object
            let updatedPermission: DefaultPermissionType = { ...defaultPermission };

            // Find the role object that matches the selected role key
            const matchedRole = rolesData?.find((item) => item.id === role_id);
            const storePermissionData = subAdminPermission[id];

            if (matchedRole && storePermissionData) {
                const commonPermissions = findCommonPermissions(
                    matchedRole.permissions,
                    storePermissionData.permission
                );

                updatedPermission[id] = {
                    isChecked: storePermissionData.isChecked,
                    permission: commonPermissions as [] ?? [],
                };

                setDefaultPermission(updatedPermission);
            }

        }
        getStructuredPermissionStoreWise(id, isChecked)
    }
    //end

    return {
        getSubAdminRoleOption,
        handleSelectedRole,
        modifiedSubAdminApiData,
        handleStorePermissionToggle
    };
};
